/** A single tab-switch button used in the App header (Calculator / Configure). */

export type TabId = 'calc' | 'config';

export interface TabButtonProps {
	id: TabId;
	label: string;
	active: boolean;
	onClick: (id: TabId) => void;
}

export function TabButton({ id, label, active, onClick }: TabButtonProps) {
	return (
		<button
			type="button"
			role="tab"
			id={`${id}-tab`}
			aria-selected={active}
			aria-controls={`${id}-panel`}
			tabIndex={active ? 0 : -1}
			onClick={() => onClick(id)}
			onKeyDown={(e) => {
				if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
					e.preventDefault();
					const newTab = id === 'calc' ? 'config' : 'calc';
					onClick(newTab);
				}
			}}
		>
			{label}
		</button>
	);
}
